import { RegistrationContractValidatorErrors, registrationContractValidator } from 'cpfr-common';
import { TFunction } from 'i18next';
import * as Yup from 'yup';
import { RegistrationContractFields } from '../RegistrationFormDataTypes';

const translationPrefix = 'registration-form.contract.validation-errors';

export const errorMessages: RegistrationContractValidatorErrors = {
    contractNumber: {
        empty: `${translationPrefix}.contract-number.empty`,
        format: `${translationPrefix}.contract-number.format`,
        format11_12: `${translationPrefix}.contract-number.format-11-12`,
        spaces: `${translationPrefix}.contract-number.spaces`,
        no_special: `${translationPrefix}.contract-number.no-special`,
    },
};

export const validationSchema = (t: TFunction): Yup.SchemaOf<RegistrationContractFields> => {
    const errors: RegistrationContractValidatorErrors = {
        contractNumber: {
            empty: t(errorMessages.contractNumber.empty),
            format: t(errorMessages.contractNumber.format),
            format11_12: t(errorMessages.contractNumber.format11_12),
            spaces: t(errorMessages.contractNumber.spaces),
            no_special: t(errorMessages.contractNumber.no_special),
        },
    };

    return registrationContractValidator(errors);
};
